import { useInspect } from "./hooks/useInspect";
import styles from "./Inspect.module.scss";
import InspectAoiMap from "./InspectAoiMap";
import InspectMap from "./InspectMap";
export default function Inspect() {
  const { item, aois, requestId, aoiId } = useInspect();

  return (
    <div className={styles["map-container"]}>
      {item && aois && (
        <>
          {!requestId && !aoiId ? (
            <InspectAoiMap validItem={item} aois={aois!} />
          ) : (
            <InspectMap validItem={item} aois={aois!} />
          )}
        </>
      )}
    </div>
  );
}
